module.exports = __webpack_public_path__ + "img/dsci0065.d8b6d493.jpg";